module.exports = __webpack_public_path__ + "de420bcb99444ee657cc27bac91d6ad0.svg";